const secondary = {
    A01: '#393832',
    A02: '#1F1E1C',
};

export default secondary;
